import type { SupSingleVaultV3, SupWeb3VaultBalance } from "@/types";
import type { SupStoredAction } from "@/types";
import React, { Dispatch } from "react";

import { SupApe, SupVaultAdd } from "@repo/core-ui";
import { SupButton, SupToast, toast } from "@repo/core-ui";

export function notifyWithdrawChange(singleVault: SupSingleVaultV3, vaultBalance: SupWeb3VaultBalance, storedDispatch: Dispatch<SupStoredAction>) {
  toast.custom(
    // @ts-ignore
    t => (
      <SupToast
        color="success"
        icon={<SupVaultAdd />}
        title="Vault Added To Bag"
        content={`Burning SuperPositions ${singleVault.friendly_name} vault ${singleVault.protocol ? `on ${singleVault.protocol.name}` : ""}`}
        actions={
          <SupButton
            prefixIcon={<SupApe />}
            variant="outlined"
            className="border border-current text-current"
            onClick={() => {
              storedDispatch({ type: "setOverlay", overlay: "withdraw" });
              toast.remove(t.id);
            }}
          >
            Open Bag
          </SupButton>
        }
        onClose={() => {
          toast.remove(t.id);
        }}
      />
    ),
    {
      id: `withdraw-${singleVault.slug}-${vaultBalance.chain_id}`,
      duration: 4000,
    }
  );
}
